<template>
  <div :class="activityClass">
    <div
      v-if="showProgress"
      class="py-2"
    >
      <bullet-graph
        :progress="count/target * 100"
      ></bullet-graph>
    </div>
    <!--
    <div
      class="progress">

      <div
        class="progress-bar progress-bar-info"
        role="progressbar"
        :aria-valuenow="count/target * 100"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="`width: ${count/target * 100}%`"></div>
    </div>
    -->
    <div :class="{
      'py-0 pl-1 pr-0': variant === 'nested',
      'py-2': variant !== 'nested'
    }">
      <div class="media">
        <div class="media-body align-self-center">
          <div class="mr-1">
            <div class="media align-items-center">
              <div
                v-if="showIcon && help"
                v-b-popover.hover.top.v-flat-peter-river="{
                  content: help
                }"
                class="media-left"
              >
                <i :class="`fa fa-fw ${iconClass} mr-2`"></i>
              </div>
              <div
                v-if="showIcon && !help"
                class="media-left"
              >
                <i :class="`fa fa-fw ${iconClass} mr-2`"></i>
              </div>
              <div class="media-body">
                <div
                  class="small font-weight-bold"
                >
                  {{ label }}
                </div>
                <div
                  v-if="tip"
                  class="small text-muted"
                >
                  {{ tip }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="showIncrementDecrement"
          class="media-right align-self-center text-right">
          <div class="d-flex align-items-center">
            <span class="h4 mb-0 pb-0 font-weight-normal mr-2">
              {{ displayCount }}
            </span>
            <button
              class="btn btn-sm btn-track-engagement btn-decrement mr-2 p-1" @click.prevent="decrement"
              :disabled="count < 1"
            >
              <i class="fa fa-fw fa-minus"></i>
            </button>
            <button class="btn btn-sm btn-track-engagement btn-decrement mr-1 p-1" @click.prevent="increment">
              <i class="fa fa-fw fa-plus"></i>
            </button>
          </div>
        </div>
        <div
          v-if="showToggle"
          class="media-right align-self-center text-right">
          <div class="d-flex align-items-center">
            <span class="h4 mb-0 pb-0 font-weight-normal mx-2">
              {{ displayCount }}
            </span>
            <button class="btn btn-sm btn-track-engagement btn-expand p-1 mr-1" @click.prevent="showNested = !showNested">
              <i
                v-show="!showNested"
                class="fa fa-fw fa-plus"></i>
              <i
                v-show="showNested"
                class="fa fa-fw fa-caret-up"></i>
            </button>
          </div>
        </div>
      </div>
      <div
        v-if="showNested"
        class="nested">
        <hr v-if="variant !== 'nested'">
        <slot />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

</style>

<script>
// import Slider from '@/components/Slider'
import BulletGraph from '@/components/BulletGraph'
import { countSimpleEngagements, incrementSimpleEngagements, decrementSimpleEngagements } from '@/api'

export default {
  components: {
    BulletGraph,
    // Slider
  },
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 'fa-block'
    },
    userId: {
      type: [String, Number],
      default: null
    },
    value: {
      type: Number,
      default: 0
    },
    history: {
      type: Number,
      default: null
    },
    help: {
      type: String,
      default: ''
    },
    target: {
      type: Number,
      default: 0
    },
    tip: {
      type: String
    },
    variant: {
      type: String,
      default: 'tracker'
    },
    type: {
      type: String,
      default: ''
    },
    leadSource: {
      type: String,
      default: ''
    },
    period: {
      type: String,
      default: 'day'
    }
  },
  computed: {
    showIncrementDecrement () {
      return this.variant === 'tracker' || this.variant === 'nested'
    },
    showToggle () {
      return this.variant === 'container'
    },
    showProgress () {
      return this.target && this.variant !== 'nested'
    },
    activityClass () {
      return `${this.variant !== 'nested' ? '' : 'mb-2'} tracker-${this.variant}`
    },
    showIcon () {
      return this.variant !== 'nested'
    },
    displayCount () {
      return (this.history || 0) + this.count
    },
    iconClass () {
      return this.loading ? 'fa-spin fa-circle-o-notch' : this.icon
    }
  },
  data () {
    return {
      showNested: false,
      count: this.value,
      loading: false
    }
  },
  watch: {
    history () {
      //
    },
    value () {
      this.count = this.value
    },
    count () {
      this.$emit('input', this.count)
    },
    period () {
      this.fetchCount()
    }
  },
  async mounted () {
    this.fetchCount()

    this.$on('childEngagementTracker.updated', () => {
      this.fetchCount()
    })

    this.$on('childEngagementTracker.incremented', () => {
      this.fetchCount()
    })

    this.$on('childEngagementTracker.decremented', () => {
      this.fetchCount()
    })
  },
  methods: {
    async fetchCount () {
      this.loading = true
      const response = await countSimpleEngagements(this.userId, this.type, this.period, this.leadSource)
      this.count = response.data.count
      this.loading = false
      this.$parent.$emit('childEngagementTracker.updated', this.userId, this.type, this.period, this.leadSource, this.count, this)
      this.$emit('engagementTracker.updated', this.userId, this.type, this.period, this.leadSource, this.count, this)
    },
    async increment () {
      this.loading = true
      const response = await incrementSimpleEngagements(this.userId, this.type, this.leadSource, this.period)
      this.count = response.data.count
      this.loading = false
      this.$parent.$emit('childEngagementTracker.incremented', this.userId, this.type, this.period, this.leadSource, this)
    },
    async decrement () {
      this.loading = true
      const response = await decrementSimpleEngagements(this.userId, this.type, this.leadSource, this.period)
      this.count = response.data.count
      this.loading = false
      this.$parent.$emit('childEngagementTracker.decremented', this.userId, this.type, this.period, this.leadSource, this)
    }
  }
}
</script>